import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import type { Observable } from 'rxjs';

import { environment } from '@env';

import type { User } from '@kernel';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly http = inject(HttpClient);
  private readonly apiBase = `${environment.userBaseUrl}/api/v2` as const;

  validateEmailInSso(
    email: string,
  ): Observable<{ authUrl: string | null; status: 'LINKED' | 'NOT_LINKED' }> {
    return this.http.post<{ authUrl: string | null; status: 'LINKED' | 'NOT_LINKED' }>(
      `${this.apiBase}/auth/sso-check`,
      { email },
    );
  }

  loginWithoutSso(request: { username: string; password: string }): Observable<User> {
    return this.http.post<User>(`${this.apiBase}/auth/login`, request);
  }

  loginWithSso(request: { code: string; state: string }): Observable<User> {
    return this.http.post<User>(`${this.apiBase}/auth/login-sso`, request);
  }

  logout(): Observable<void> {
    return this.http.post<void>(`${this.apiBase}/auth/logout`, {});
  }
}
